import Dashboard from "layouts/Dashboard";

export const indexRoutes = [ { path: "/", name: "Home", component: Dashboard } ];
